var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnknownLink = function SvgUnknownLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.462 10a8.461 8.461 0 1 1-16.923 0 8.461 8.461 0 0 1 16.923 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M10 20C4.54 20 0 15.46 0 10 0 4.53 4.53 0 9.99 0 15.46 0 20 4.53 20 10c0 5.46-4.53 10-10 10m-.206-7.902c.51 0 .824-.324.824-.726v-.117c0-.569.323-.932 1.03-1.392.98-.647 1.685-1.236 1.685-2.451 0-1.687-1.5-2.579-3.225-2.579-1.745 0-2.883.814-3.157 1.745a1.7 1.7 0 0 0-.088.5c0 .451.362.697.696.697.343 0 .568-.167.755-.402l.176-.246c.363-.588.883-.921 1.559-.921.912 0 1.51.52 1.51 1.284 0 .686-.422 1.02-1.304 1.637-.726.51-1.275 1.04-1.275 2.04v.127c0 .53.295.804.814.804m-.02 3.01c.589 0 1.099-.46 1.099-1.05 0-.587-.5-1.058-1.098-1.058s-1.099.48-1.099 1.059c0 .578.51 1.049 1.099 1.049"
  })));
};
export default SvgUnknownLink;